import { Flex, LogmarSelector, Text } from './shared';
import { useState, useEffect } from 'react';
import { useTestContext } from '../../../context/testContext';

const ResponsiveLogmarSelection = ({ eyeTested, noCharacters }) => {
  const [selectedLogmar, setSelectedLogmar] = useState({ id: 1, value: 1 });
  const { updateTestData, logmarCharacters, generateLogmarCharacters } = useTestContext();

  useEffect(() => {
    if (!noCharacters) generateLogmarCharacters();
  }, [noCharacters, generateLogmarCharacters]);

  useEffect(() => {
    updateTestData({ eyeTested: selectedLogmar });
  }, [selectedLogmar, eyeTested, updateTestData, logmarCharacters]);

  return (
    <Flex column centered>
      <Text marginBottom='1rem'>Please select a starting logMAR.</Text>
      <LogmarSelector
        logmarCharacters={noCharacters ? null : logmarCharacters}
        selectedLogmar={selectedLogmar}
        setSelectedLogmar={setSelectedLogmar}
      />
    </Flex>
  );
};

export default ResponsiveLogmarSelection;
